<div class="loginContainer">
  <div class="innerContainer">
    <i [ngClass]="'app-offline-welcome'" class="csx-device_wifi" style="margin-left: 10px;"><span></span></i>
    <br />
    <span class="onlineNotification">System is Offline</span>
    <br />
    <span class="userconfirmation">Are you "{{userName}}"?</span>
    <br />
    <button type="button" class="loginbtn" (click)="verifyUser(true)" name="button">If Yes - access in offline mode</button>
    <br />
    <span class="bottomspanfirst">Not "{{userName}}"?</span>
    <br />
    <span class="bottomspansecond">Login when online</span>
  </div>
</div>